// Tiptap extensions
import Blockquote from '@tiptap/extension-blockquote';
import Bold from '@tiptap/extension-bold';
import BulletList from '@tiptap/extension-bullet-list';
import Document from '@tiptap/extension-document';
import Gapcursor from '@tiptap/extension-gapcursor';
import Heading from '@tiptap/extension-heading';
import History from '@tiptap/extension-history';
import Italic from '@tiptap/extension-italic';
import Link from '@tiptap/extension-link';
import ListItem from '@tiptap/extension-list-item';
import ListKeymap from '@tiptap/extension-list-keymap';
import OrderedList from '@tiptap/extension-ordered-list';
import Paragraph from '@tiptap/extension-paragraph';
import Placeholder from '@tiptap/extension-placeholder';
import Superscript from '@tiptap/extension-superscript';
import Table from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import Text from '@tiptap/extension-text';

// Custom extensions
import Alert from '@plugins/tiptap/extensions/Alert';
import Checkbox from '@plugins/tiptap/extensions/Checkbox';
import Config from '@plugins/tiptap/extensions/Config';
import DynamicValue from '@plugins/tiptap/extensions/DynamicValue';
import ExpansionPanel from '@plugins/tiptap/extensions/ExpansionPanel';
import Input from '@plugins/tiptap/extensions/Input';
import Outline from '@plugins/tiptap/extensions/Outline';
import RadioItem from '@plugins/tiptap/extensions/RadioItem';
import RadioList from '@plugins/tiptap/extensions/RadioList';
import Readonly from '@plugins/tiptap/extensions/Readonly';
import Validator from '@plugins/tiptap/extensions/Validator';

export default [
    // Tiptap extensions
    Document,
    Paragraph,
    Heading,
    Text,
    Bold,
    Italic,
    Link,
    ListItem,
    ListKeymap,
    BulletList,
    OrderedList,
    Blockquote,
    History,
    Placeholder.configure({
        placeholder: () => 'Write something...'
    }),
    Gapcursor,
    Table.configure({ resizable: false }),
    TableRow,
    TableHeader,
    TableCell,
    Superscript,

    // Custom extensions
    Checkbox,
    ExpansionPanel,
    Alert,
    DynamicValue,
    RadioList,
    RadioItem,
    Readonly,
    Input,
    Config,
    Validator,
    Outline
];
